module.exports = __webpack_public_path__ + "img/lor_olympique_6s.e2800181.jpg";